import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://api.cognecto.com",
    withCredentials: true,
    timeout: 15000,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");


    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
});

export default axiosInstance;